export default {
  ACCESS_TOKEN: process.env.REACT_APP_STYCH_MAPBOX_TOKEN
};
